import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  updateFormList,
  updateNewFormList,
  formEdited,
} from "FormBuilderAction";
import LocaleStrings from "Languages";
import Select from "react-select";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

// Each field's variableName kept hidden as we are not allowing user to edit name key in each json. Coe update by Vinay on 03-12-2020
var saveObj = [];
class FormList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labelName: "",
      variableName: "",
      maxLen: "",
      isactive: true,
      required: false,
      imgHeight: "100",
      imgWidth: "100",
      link: "",
      optionsArray: [],
      reviewerVisible: false,
      descriptionName: "",
      descriptionVariable: "",
    };
    this.overlayRef = React.createRef();
  }

  componentDidMount() {
    var { list } = this.props;

    // if(list.key == 'checkboxes' || list.key == 'radiobuttons' || list.key == 'dropdown' ) {
    //     this.setState({optionsArray: list.options});
    // }
  }

  /**
   * Clear all states and array
   */
  // clearAll = () => {
  //     this.setState({
  //         labelName: '',
  //         maxLen: '',
  //         required: false,
  //         imgWidth: "100",
  //         imgWidth: "100",
  //         optionsArray: [],
  //     });
  //     saveObj = [];
  // }

  /**
   * Check which form list opened for setting changes
   */
  openedList = (list) => {
    if (
      list.key == "textinput" ||
      list.key == "numberinput" ||
      list.key == "textarea"
    ) {
      this.setState({
        labelName: list.label,
        variableName: list.name,
        maxLen: list.maxlen,
        isactive: list.isactive,
        required: list.required,
      });
    }
    if (list.key == "image") {
      this.setState({
        variableName: list.name,
        isactive: list.isactive,
        required: list.required,
        imgHeight: list.height,
        imgWidth: list.width,
      });
    }
    if (list.key == "datepicker" || list.key == "rating") {
      this.setState({
        labelName: list.label,
        variableName: list.name,
        isactive: list.isactive,
        required: list.required,
      });
    }
    if (list.key == "hyperlink") {
      this.setState({
        labelName: list.label,
        variableName: list.name,
        isactive: list.isactive,
        required: list.required,
        link: list.link,
      });
    }
    if (
      list.key == "checkboxes" ||
      list.key == "radiobuttons" ||
      list.key == "dropdown"
    ) {
      this.setState({
        labelName: list.label,
        variableName: list.name,
        isactive: list.isactive,
        required: list.required,
        optionsArray: list.options,
      });
    }
    if (list.key == "singlecheckbox") {
      this.setState({
        labelName: list.label,
        variableName: list.name,
        isactive: list.isactive,
        required: list.required,
      });
    }
    if (list.key == "label" || list.key == "paragraph") {
      this.setState({
        labelName: list.label,
        variableName: list.name,
        isactive: list.isactive,
      });
    }
    if (list.key == "file") {
      this.setState({
        labelName: list.label,
        variableName: list.name,
        isactive: list.isactive,
        maxuploader: list.maxupload,
        filetype: list.filetype,
        maxuploadersize: list.maxuploadsize,
      });
    }
    if (list.key == "group") {
      if (list.type == "abstract") {
        this.setState({
          isactive: list.isactive,
          labelName: list.groupfields[0].label,
          variableName: list.groupfields[0].name,
          descriptionName: list.groupfields[1].label,
          descriptionVariable: list.groupfields[1].name,
        });
      } else {
        this.setState({
          labelName: list.label,
          variableName: list.name,
          isactive: list.isactive,
          maxGroupEntry: list.maxentries,
        });
      }
    }
  };

  /**
   * Remove from form list
   */
  removeFromList = () => {
    this.props.updateFormList(this.props.list, this.props.oldKeys, "remove");
    this.props.formEdited(true); // This is used for edit form
  };

  /**
   * Remove from multiple choice fields option
   */
  removeOptions = (i) => {
    var { list } = this.props;
    var { optionsArray } = this.state;

    // var removeValFrom  = [i];
    optionsArray = optionsArray.filter(function (value, index) {
      // return removeValFrom.indexOf(index) == -1;
      return index != i;
    });

    this.setState({ optionsArray });
  };

  /**
   * Add new option to multiple choice fields option
   */
  addOptions = () => {
    var { list } = this.props;
    var { optionsArray } = this.state;
    var opArray = optionsArray.slice();
    var newRow = { value: "", text: "", displayfields: "" };

    opArray.push(newRow);
    this.setState({ optionsArray: opArray });
  };

  /**
   * Form data setting related work
   */
  labelChange = (e) => {
    this.setState({ labelName: e.target.value });
  };

  variableChange = (e) => {
    let val = e.target.value;
    var regex = /^[A-Za-z0-9_]*$/;
    var isValid = regex.test(val);

    if (isValid) {
      this.setState({ variableName: val });
    } else {
      this.setState({ variableName: this.state.variableName });
    }
  };

  linkChange = (e) => {
    this.setState({ link: e.target.value });
  };

  isActive = (e) => {
    this.setState({ isactive: e.target.checked });
  };

  isRequired = (e) => {
    this.setState({ required: e.target.checked });
  };

  maxLenChange = (e) => {
    this.setState({ maxLen: e.target.value });
  };

  imageHeight = (e) => {
    this.setState({ imgHeight: e.target.value });
  };

  imageWidth = (e) => {
    this.setState({ imgWidth: e.target.value });
  };

  optionText = (e, i) => {
    var { optionsArray } = this.state;

    optionsArray.splice(i, 1, {
      value: optionsArray[i].value,
      text: e.target.value,
      displayfields: optionsArray[i].displayfields,
    });
    this.setState({ optionsArray });
  };

  optionValue = (e, i) => {
    var { optionsArray } = this.state;

    optionsArray.splice(i, 1, {
      value: e.target.value,
      text: optionsArray[i].text,
      displayfields: optionsArray[i].displayfields,
    });
    this.setState({ optionsArray });
  };

  optionSelect = (e, i) => {
    var { optionsArray } = this.state;
    optionsArray.splice(i, 1, {
      value: optionsArray[i].value,
      text: optionsArray[i].text,
      displayfields: this.getDisplayFields(e),
    });
    this.setState({ optionsArray });
  };

  descriptionChange = (e) => {
    this.setState({ descriptionName: e.target.value });
  };

  descVariableChange = (e) => {
    let val = e.target.value;
    var regex = /^[A-Za-z0-9_]*$/;
    var isValid = regex.test(val);

    if (isValid) {
      this.setState({ descriptionVariable: val });
    } else {
      this.setState({ descriptionVariable: this.state.descriptionVariable });
    }
  };

  maxUploaderChange = (e) => {
    this.setState({ maxuploader: e.target.value });
  };

  // maxUploaderSizeChange = (e) => {
  //   this.setState({ maxuploadersize: e.target.value });
  // };

  maxGroupDataEnteries = (e) => {
    this.setState({ maxGroupEntry: e.target.value });
  };

  fileTypeChange = (e) => {
    this.setState({ filetype: e.target.value });
  };

  preventPress = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  getDisplayFields = (e) => {
    let temp = "";
    for (let i = 0; i < e.length; i++) {
      if (i + 1 == e.length) {
        temp = temp.concat(e[i].value);
      } else {
        temp = temp.concat(e[i].value, ",");
      }
    }
    return temp;
  };

  saveData = (list) => {
    var {
      labelName,
      variableName,
      isactive,
      required,
      maxLen,
      imgHeight,
      imgWidth,
      link,
      reviewerVisible,
      maxuploader,
      maxGroupEntry,
      optionsArray,
      descriptionName,
      descriptionVariable,
    } = this.state;
    var error = false;
    var errorMessage = "";

    let uniqueVariable = _.filter(this.props.oldKeys, (obj) => {
      return obj.name == variableName;
    });

    if (
      list.key == "textinput" ||
      list.key == "numberinput" ||
      list.key == "textarea"
    ) {
      if (labelName == "" || maxLen == "") {
        error = true;
        errorMessage =
          LocaleStrings.dynamic_form_validation_label_max_length_required;
      }
      if (variableName == "") {
        error = true;
        errorMessage = LocaleStrings.dynamic_form_validation_variable_required;
      }
      if (
        variableName !== "" &&
        list.name !== variableName &&
        uniqueVariable.length > 0
        // || variableName.toLowerCase() == "firstname" ||
        // variableName.toLowerCase() == "lastname" ||
        // variableName.toLowerCase() == "email"
      ) {
        error = true;
        errorMessage =
          LocaleStrings.dynamic_form_validation_variable_already_used;
      }
      saveObj = {
        ...list,
        isactive: isactive,
        required: required,
        maxlen: maxLen,
        label: labelName,
        name: variableName,
        reviewerVisible: reviewerVisible,
      };
    }
    if (
      list.key == "checkboxes" ||
      list.key == "radiobuttons" ||
      list.key == "dropdown"
    ) {
      if (labelName == "") {
        error = true;
        errorMessage =
          LocaleStrings.dynamic_form_validation_label_of_checkbox_radio_dropdown_required;
      }
      if (variableName == "") {
        error = true;
        errorMessage = LocaleStrings.dynamic_form_validation_variable_required;
      }
      if (
        variableName !== "" &&
        list.name !== variableName &&
        uniqueVariable.length > 0
      ) {
        error = true;
        errorMessage =
          LocaleStrings.dynamic_form_validation_variable_already_used;
      }
      _.map(this.state.optionsArray, (opt) => {
        if (!opt.value || !opt.text) {
          error = true;
          errorMessage =
            LocaleStrings.dynamic_form_validation_provide_proper_option_value;
        }
      });
      saveObj = {
        ...list,
        name: variableName,
        label: labelName,
        isactive: isactive,
        required: required,
        hasCondition: this.getHasCondition(optionsArray),
        options: optionsArray,
      };
    }
    if (list.key == "singlecheckbox") {
      if (labelName == "") {
        error = true;
        errorMessage = LocaleStrings.dynamic_form_validation_label_required;
      }
      saveObj = {
        ...list,
        isactive: isactive,
        required: required,
        name: variableName,
        label: labelName,
      };
    }
    if (list.key == "image") {
      saveObj = {
        ...list,
        isactive: isactive,
        required: required,
        name: variableName,
        label: list.label,
        width: imgHeight,
        height: imgWidth,
      };
    }
    if (list.key == "datepicker" || list.key == "rating") {
      if (labelName == "") {
        error = true;
        errorMessage =
          LocaleStrings.dynamic_form_validation_label_of_datepicker_rating_required;
      }
      if (variableName == "") {
        error = true;
        errorMessage = LocaleStrings.dynamic_form_validation_variable_required;
      }
      if (
        variableName !== "" &&
        list.name !== variableName &&
        uniqueVariable.length > 0
      ) {
        error = true;
        errorMessage =
          LocaleStrings.dynamic_form_validation_variable_already_used;
      }
      saveObj = {
        ...list,
        name: variableName,
        label: labelName,
        isactive: isactive,
        required: required,
      };
    }
    if (list.key == "hyperlink") {
      var re =
        /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
      if (labelName == "") {
        error = true;
        errorMessage =
          LocaleStrings.dynamic_form_validation_label_of_hyperlink_required;
      }
      if (link == "" || !re.test(link)) {
        error = true;
        errorMessage = LocaleStrings.dynamic_form_validation_invalid_url_link;
      }
      saveObj = {
        ...list,
        name: variableName,
        label: labelName,
        link: link,
        isactive: isactive,
        required: required,
      };
    }
    if (list.key == "label") {
      if (labelName == "") {
        error = true;
        errorMessage = LocaleStrings.dynamic_form_validation_label_required;
      }
      saveObj = {
        ...list,
        name: variableName,
        label: labelName,
        isactive: isactive,
        required: required,
      };
    }
    if (list.key == "paragraph") {
      if (labelName == "") {
        error = true;
        errorMessage = LocaleStrings.dynamic_form_validation_paragraph_required;
      }
      saveObj = {
        ...list,
        name: variableName,
        label: labelName,
        isactive: isactive,
        required: required,
      };
    }
    if (list.key == "file") {
      let filetype = this.state.filetype;
      let maxuploadersize = this.state.maxuploadersize;

      if (maxuploader == "" || maxuploader == 0) {
        error = true;
        errorMessage =
          LocaleStrings.dynamic_form_validation_max_uploader_required;
      }
      if (variableName == "") {
        error = true;
        errorMessage = LocaleStrings.dynamic_form_validation_variable_required;
      }
      if (
        variableName !== "" &&
        list.name !== variableName &&
        uniqueVariable.length > 0
      ) {
        error = true;
        errorMessage =
          LocaleStrings.dynamic_form_validation_variable_already_used;
      }
      saveObj = {
        ...list,
        isactive: isactive,
        required: required,
        maxupload: maxuploader,
        label: labelName,
        name: variableName,
        reviewerVisible: reviewerVisible,
        filetype: filetype.toLowerCase(),
        maxuploadsize: maxuploadersize,
      };
    }
    if (list.key == "group") {
      if (list.type == "abstract") {
        if (labelName == "") {
          error = true;
          errorMessage =
            LocaleStrings.dynamic_form_validation_label_of_group_required;
        }
        if (variableName == "") {
          error = true;
          errorMessage =
            LocaleStrings.dynamic_form_validation_variable_required;
        }
        if (descriptionName == "") {
          error = true;
          errorMessage =
            LocaleStrings.dynamic_form_validation_label_of_group_required;
        }
        if (descriptionVariable == "") {
          error = true;
          errorMessage =
            LocaleStrings.dynamic_form_validation_variable_required;
        }
        let obj = { ...list };
        obj.groupfields[0].label = labelName;
        obj.groupfields[0].name = variableName;
        obj.groupfields[1].label = descriptionName;
        obj.groupfields[1].name = descriptionVariable;

        saveObj = { ...obj, isactive: isactive };
      } else {
        if (labelName == "") {
          error = true;
          errorMessage =
            LocaleStrings.dynamic_form_validation_label_of_group_required;
        }
        if (maxGroupEntry == "" || maxGroupEntry < 1) {
          error = true;
          errorMessage =
            LocaleStrings.dynamic_form_validation_maxgroupentries_required;
        }
        if (variableName == "") {
          error = true;
          errorMessage =
            LocaleStrings.dynamic_form_validation_variable_required;
        }
        if (
          variableName !== "" &&
          list.name !== variableName &&
          uniqueVariable.length > 0
        ) {
          error = true;
          errorMessage =
            LocaleStrings.dynamic_form_validation_variable_already_used;
        }
        saveObj = {
          ...list,
          isactive: isactive,
          label: labelName,
          maxentries: maxGroupEntry,
        };
      }
    }

    if (error) {
      this.props.showError(errorMessage);
    } else {
      this.props.updateNewFormList(saveObj, this.props.oldKeys);
      this.props.formEdited(true); // This is used for edit form
      document.body.click();
    }
  };
  /**
   * ==================================================
   */

  getHasCondition(optionsArray) {
    let hasCondition = false;
    for (let i = 0; i < optionsArray.length; i++) {
      if (optionsArray[i].displayfields !== "") {
        hasCondition = true;
        break;
      }
    }
    return hasCondition;
  }

  getDefaults = (optionsArray, dropdownArrMulti) => {
    let dropdownArrMultiDefaults = [];

    for (let i = 0; i < optionsArray.length; i++) {
      if (optionsArray[i].displayfields) {
        let displayfieldsArr = optionsArray[i].displayfields.split(",");
        dropdownArrMultiDefaults[i] = [];
        for (let j = 0; j < displayfieldsArr.length; j++) {
          let tempArr = _.filter(
            dropdownArrMulti,
            (temp) => temp.value == displayfieldsArr[j]
          );
          dropdownArrMultiDefaults[i] = _.concat(
            dropdownArrMultiDefaults[i],
            tempArr
          );
        }
      } else {
        dropdownArrMultiDefaults[i] = [];
      }
    }

    return dropdownArrMultiDefaults;
  };

  formData = () => {
    var { list, source } = this.props;
    var { optionsArray, variableName } = this.state;

    var list_name = list["name"];
    var oldList = this.props.oldKeys;
    var dropdownArr = [];
    var dropdownArrMulti = [];
    var dropdownArrMultiDefaults = [];

    var listIndex = _.findIndex(oldList, { name: list_name });
    dropdownArr = _.slice(oldList, listIndex + 1, oldList.length + 1);
    dropdownArr = _.filter(
      dropdownArr,
      (temp) =>
        !(temp.name === "termsconditions" || temp.name === "isnetworking")
    );

    _.map(dropdownArr, (opt) => {
      dropdownArrMulti = _.concat(dropdownArrMulti, [
        { label: opt.label, value: opt.name },
      ]);
    });

    dropdownArrMultiDefaults = this.getDefaults(optionsArray, dropdownArrMulti);
    // console.log("list : - ", list);
    // console.log("source : - ", source);

    var showIsRequired = true;
    var showIsPublic = true;
    if (source === "sessionrating") {
      showIsRequired = false;
    }
    if (list.key === "file" && list.defaultfields == true) {
      showIsRequired = false;
    }

    if (
      ((source === "checkout" || source == "proposal") &&
        (list_name === "designation" || list_name === "company")) ||
      source === "sessionrating"
    ) {
      showIsPublic = false;
    }

    var style = {};
    if (
      list.key === "dropdown" ||
      list.key === "checkboxes" ||
      list.key === "radiobuttons"
    ) {
      style = { maxWidth: 750 };
    } else if (list.key === "group" && list.type == "abstract") {
      style = { minWidth: 700 };
    }

    var defaultFileTypeOptions = [
      { value: "image", text: "Image" },
      { value: "document", text: "Documents(PDF/Docx/PPT/XLSX/Zip)" },
      { value: "video", text: "Video" },
      { value: "audio", text: "Audio" },
    ];

    if (source === "proposal" || source == "sponsor" || source == "exhibitor") {
      defaultFileTypeOptions = [
        { value: "image", text: "Image" },
        { value: "document", text: "Documents(PDF/Docx/PPT/XLSX/Zip)" },
      ];
    }

    return (
      <Popover
        title={list.header ? list.header : list.label}
        id="popover-basic"
        style={style}
      >
        <div style={{ padding: "10px" }}>
          {list.key === "textinput" ||
          list.key === "numberinput" ||
          list.key === "textarea" ? (
            <div>
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.label}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"label_" + list.id}
                    id={"label_" + list.id}
                    defaultValue={list.label}
                    onChange={this.labelChange}
                  />
                </div>
              </div>
              {list.defaultfields ? (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.variable} :
                  </label>{" "}
                  {list.name}
                </div>
              ) : (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.variable}
                  </label>
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      name={"variable_" + list.id}
                      id={"variable_" + list.id}
                      value={variableName}
                      onChange={this.variableChange}
                    />
                  </div>
                </div>
              )}
              {showIsPublic === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"isactive_" + list.id}
                    id={"isactive_" + list.id}
                    defaultChecked={list.isactive ? true : false}
                    onChange={this.isActive}
                  />
                  <span> {LocaleStrings.public}</span>
                </div>
              ) : (
                ""
              )}
              {showIsRequired === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"required_" + list.id}
                    id={"required_" + list.id}
                    defaultChecked={list.required ? true : false}
                    onChange={this.isRequired}
                  />
                  <span> {LocaleStrings.required}</span>
                </div>
              ) : (
                ""
              )}
              {source && source == "proposal" ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"reviewervisible_" + list.id}
                    id={"reviewervisible_" + list.id}
                    defaultChecked={list.reviewerVisible ? true : false}
                    onChange={this.isReviewerVisible}
                  />
                  <span> {LocaleStrings.reviewervisible}</span>
                </div>
              ) : (
                ""
              )}
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.max_length}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"maxlen_" + list.id}
                    id={"maxlen_" + list.id}
                    defaultValue={list.maxlen}
                    onChange={this.maxLenChange}
                  />
                </div>
              </div>
              <hr />
              <div className="">
                <button
                  id="save"
                  className="btn btn-custom-blue"
                  onClick={() => this.saveData(list)}
                >
                  {LocaleStrings.button_save}
                </button>
                &nbsp;
                <button
                  id="cancel"
                  className="btn  btn-custom-white"
                  onClick={() => document.body.click()}
                >
                  {LocaleStrings.button_cancel}
                </button>
              </div>
            </div>
          ) : list.key === "dropdown" ||
            list.key === "checkboxes" ||
            list.key === "radiobuttons" ? (
            <div
              style={{
                height: "430px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.label}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"label_" + list.id}
                    id={"label_" + list.id}
                    defaultValue={list.label}
                    onChange={this.labelChange}
                  />
                </div>
              </div>
              {list.defaultfields ? (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.variable} :
                  </label>{" "}
                  {list.name}
                </div>
              ) : (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.variable}
                  </label>
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      name={"variable_" + list.id}
                      id={"variable_" + list.id}
                      value={variableName}
                      onChange={this.variableChange}
                    />
                  </div>
                </div>
              )}
              {showIsPublic === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"isactive_" + list.id}
                    id={"isactive_" + list.id}
                    defaultChecked={list.isactive ? true : false}
                    onChange={this.isActive}
                  />
                  <span> {LocaleStrings.public}</span>
                </div>
              ) : (
                ""
              )}
              {showIsRequired === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"required_" + list.id}
                    id={"required_" + list.id}
                    defaultChecked={list.required ? true : false}
                    onChange={this.isRequired}
                  />
                  <span> {LocaleStrings.required}</span>
                </div>
              ) : (
                ""
              )}
              <div className="dynamic-option-list popover-options">
                <div className="row">
                  <div className="col-sm-4">
                    <b>{LocaleStrings.options}</b>
                  </div>
                  <div className="col-sm-4">
                    <b>{LocaleStrings.values}</b>
                  </div>
                  {/* <div className="col-sm-3">
                  <b>{LocaleStrings.select}</b>654
                </div> */}
                </div>

                {_.map(optionsArray, (opt, i) => {
                  return (
                    <div className="row clearfix form-group" key={i}>
                      <div className="col-sm-4">
                        <input
                          tabIndex={i + 1}
                          className="form-control"
                          type="text"
                          name={"text_" + i}
                          value={opt.text}
                          onChange={(e) => this.optionText(e, i)}
                        />
                      </div>
                      <div className="col-sm-4">
                        <input
                          className="form-control"
                          type="text"
                          name={"value_" + i}
                          value={opt.value}
                          onChange={(e) => this.optionValue(e, i)}
                        />
                      </div>

                      {/* <div className="col-sm-3">
                     
                      <ReactMultiSelectCheckboxes
                        options={dropdownArrMulti}
                        value={dropdownArrMultiDefaults[i]}
                        maxMenuHeight={1000}
                        onChange={(e) => this.optionSelect(e, i)}
                      />
                    </div> */}

                      <div className="col-sm-4">
                        <div className="dynamic-options-actions-buttons">
                          {i === 0 ? (
                            <button
                              className="btn btn-success"
                              onClick={() => this.addOptions(i)}
                            >
                              <i className="fa fa-plus-circle"></i>
                            </button>
                          ) : (
                            <button
                              className="btn btn-danger"
                              onClick={() => this.removeOptions(i)}
                            >
                              <i className="fa fa-minus-circle"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <hr />
              <div className="">
                <button
                  id="save"
                  className="btn btn-custom-blue"
                  onClick={() => this.saveData(list)}
                >
                  {LocaleStrings.button_save}
                </button>
                &nbsp;
                <button
                  id="cancel"
                  className="btn btn-custom-white"
                  onClick={() => document.body.click()}
                >
                  {LocaleStrings.button_cancel}
                </button>
              </div>
            </div>
          ) : list.key === "singlecheckbox" ? (
            <div>
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.label}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"label_" + list.id}
                    id={"label_" + list.id}
                    defaultValue={list.label}
                    onChange={this.labelChange}
                  />
                </div>
              </div>
              {showIsPublic === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"isactive_" + list.id}
                    id={"isactive_" + list.id}
                    defaultChecked={list.isactive ? true : false}
                    onChange={this.isActive}
                  />
                  <span> {LocaleStrings.public}</span>
                </div>
              ) : (
                ""
              )}
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.variable} :
                </label>{" "}
                {list.name}
              </div>
              <hr />
              <div className="">
                <button
                  id="save"
                  className="btn btn-custom-blue"
                  onClick={() => this.saveData(list)}
                >
                  {LocaleStrings.button_save}
                </button>
                &nbsp;
                <button
                  id="cancel"
                  className="btn btn-custom-white"
                  onClick={() => document.body.click()}
                >
                  {LocaleStrings.button_cancel}
                </button>
              </div>
            </div>
          ) : list.key === "image" ? (
            <div>
              {showIsPublic === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"isactive_" + list.id}
                    id={"isactive_" + list.id}
                    defaultChecked={list.isactive ? true : false}
                    onChange={this.isActive}
                  />
                  <span> {LocaleStrings.public}</span>
                </div>
              ) : (
                ""
              )}
              {showIsRequired === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"required_" + list.id}
                    id={"required_" + list.id}
                    defaultChecked={list.required ? true : false}
                    onChange={this.isRequired}
                  />
                  <span> {LocaleStrings.required}</span>
                </div>
              ) : (
                ""
              )}
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.width}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"width_" + list.id}
                    id={"width_" + list.id}
                    defaultValue={list.width}
                    onChange={this.imageWidth}
                  />
                </div>
              </div>
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.height}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"height_" + list.id}
                    id={"height_" + list.id}
                    defaultValue={list.height}
                    onChange={this.imageHeight}
                  />
                </div>
              </div>
              <hr />
              <div className="">
                <button
                  id="save"
                  className="btn btn-custom-blue"
                  onClick={() => this.saveData(list)}
                >
                  {LocaleStrings.button_save}
                </button>
                &nbsp;
                <button
                  id="cancel"
                  className="btn btn-custom-white"
                  onClick={() => document.body.click()}
                >
                  {LocaleStrings.button_cancel}
                </button>
              </div>
            </div>
          ) : list.key === "hyperlink" ? (
            <div>
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.label}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"label_" + list.id}
                    id={"label_" + list.id}
                    defaultValue={list.label}
                    onChange={this.labelChange}
                  />
                </div>
              </div>
              {showIsPublic === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"isactive_" + list.id}
                    id={"isactive_" + list.id}
                    defaultChecked={list.isactive ? true : false}
                    onChange={this.isActive}
                  />
                  <span> {LocaleStrings.public}</span>
                </div>
              ) : (
                ""
              )}
              <div className="form-group">
                <label style={{ textAlign: "left" }}>{LocaleStrings.url}</label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"link_" + list.id}
                    id={"link_" + list.id}
                    defaultValue={list.link}
                    onChange={this.linkChange}
                  />
                </div>
              </div>
              <hr />
              <div className="">
                <button
                  id="save"
                  className="btn btn-custom-blue"
                  onClick={() => this.saveData(list)}
                >
                  {LocaleStrings.button_save}
                </button>
                &nbsp;
                <button
                  id="cancel"
                  className="btn btn-custom-white"
                  onClick={() => document.body.click()}
                >
                  {LocaleStrings.button_cancel}
                </button>
              </div>
            </div>
          ) : list.key === "rating" ? (
            <div>
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.label}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"label_" + list.id}
                    id={"label_" + list.id}
                    defaultValue={list.label}
                    onChange={this.labelChange}
                  />
                </div>
              </div>
              {list.defaultfields ? (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.variable} :
                  </label>{" "}
                  {list.name}
                </div>
              ) : (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.variable}
                  </label>
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      name={"variable_" + list.id}
                      id={"variable_" + list.id}
                      value={variableName}
                      onChange={this.variableChange}
                    />
                  </div>
                </div>
              )}
              {showIsPublic === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"isactive_" + list.id}
                    id={"isactive_" + list.id}
                    defaultChecked={list.isactive ? true : false}
                    onChange={this.isActive}
                  />
                  <span> {LocaleStrings.public}</span>
                </div>
              ) : (
                ""
              )}
              {showIsRequired === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"required_" + list.id}
                    id={"required_" + list.id}
                    defaultChecked={list.required ? true : false}
                    onChange={this.isRequired}
                  />
                  <span> {LocaleStrings.required}</span>
                </div>
              ) : (
                ""
              )}
              <hr />
              <div className="">
                <button
                  id="save"
                  className="btn btn-custom-blue"
                  onClick={() => this.saveData(list)}
                >
                  {LocaleStrings.button_save}
                </button>
                &nbsp;
                <button
                  id="cancel"
                  className="btn btn-custom-white"
                  onClick={() => document.body.click()}
                >
                  {LocaleStrings.button_cancel}
                </button>
              </div>
            </div>
          ) : list.key === "datepicker" ? (
            <div>
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.label}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"label_" + list.id}
                    id={"label_" + list.id}
                    defaultValue={list.label}
                    onChange={this.labelChange}
                  />
                </div>
              </div>
              {list.defaultfields ? (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.variable} :
                  </label>{" "}
                  {list.name}
                </div>
              ) : (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.variable}
                  </label>
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      name={"variable_" + list.id}
                      id={"variable_" + list.id}
                      value={variableName}
                      onChange={this.variableChange}
                    />
                  </div>
                </div>
              )}
              {showIsPublic === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"isactive_" + list.id}
                    id={"isactive_" + list.id}
                    defaultChecked={list.isactive ? true : false}
                    onChange={this.isActive}
                  />
                  <span> {LocaleStrings.public}</span>
                </div>
              ) : (
                ""
              )}
              {showIsRequired === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"required_" + list.id}
                    id={"required_" + list.id}
                    defaultChecked={list.required ? true : false}
                    onChange={this.isRequired}
                  />
                  <span> {LocaleStrings.required}</span>
                </div>
              ) : (
                ""
              )}
              <hr />
              <div className="">
                <button
                  id="save"
                  className="btn btn-custom-blue"
                  onClick={() => this.saveData(list)}
                >
                  {LocaleStrings.button_save}
                </button>
                &nbsp;
                <button
                  id="cancel"
                  className="btn btn-custom-white"
                  onClick={() => document.body.click()}
                >
                  {LocaleStrings.button_cancel}
                </button>
              </div>
            </div>
          ) : list.key === "label" || list.key === "paragraph" ? (
            <div>
              {list.key === "label" ? (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.label}
                  </label>
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      name={"label_" + list.id}
                      id={"label_" + list.id}
                      defaultValue={list.label}
                      onChange={this.labelChange}
                    />
                  </div>
                </div>
              ) : (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.paragraph}
                  </label>
                  <div>
                    <textarea
                      className="form-control"
                      name={"label_" + list.id}
                      id={"label_" + list.id}
                      defaultValue={list.label}
                      onChange={this.labelChange}
                    >
                      {/* {list.label}  */}
                    </textarea>
                  </div>
                </div>
              )}
              {showIsPublic === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"isactive_" + list.id}
                    id={"isactive_" + list.id}
                    defaultChecked={list.isactive ? true : false}
                    onChange={this.isActive}
                  />
                  <span> {LocaleStrings.public}</span>
                </div>
              ) : (
                ""
              )}
              <hr />
              <div className="">
                <button
                  id="save"
                  className="btn btn-custom-blue"
                  onClick={() => this.saveData(list)}
                >
                  {LocaleStrings.button_save}
                </button>
                &nbsp;
                <button
                  id="cancel"
                  className="btn btn-custom-white"
                  onClick={() => document.body.click()}
                >
                  {LocaleStrings.button_cancel}
                </button>
              </div>
            </div>
          ) : list.key === "file" ? (
            <div>
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.label}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"label_" + list.id}
                    id={"label_" + list.id}
                    defaultValue={list.label}
                    onChange={this.labelChange}
                  />
                </div>
              </div>
              {list.defaultfields ? (
                <span>
                  <div className="form-group">
                    <label style={{ textAlign: "left" }}>
                      {LocaleStrings.variable} :
                    </label>{" "}
                    {list.name}
                  </div>
                </span>
              ) : (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.variable}
                  </label>
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      name={"variable_" + list.id}
                      id={"variable_" + list.id}
                      value={variableName}
                      onChange={this.variableChange}
                    />
                  </div>
                </div>
              )}
              {showIsPublic === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"isactive_" + list.id}
                    id={"isactive_" + list.id}
                    defaultChecked={list.isactive ? true : false}
                    onChange={this.isActive}
                  />
                  <span> {LocaleStrings.public}</span>
                </div>
              ) : (
                ""
              )}
              {showIsRequired === true ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"required_" + list.id}
                    id={"required_" + list.id}
                    defaultChecked={list.required ? true : false}
                    onChange={this.isRequired}
                  />
                  <span> {LocaleStrings.required}</span>
                </div>
              ) : (
                ""
              )}
              {source && source == "proposal" ? (
                <div className="form-group">
                  <input
                    type="checkbox"
                    name={"reviewervisible_" + list.id}
                    id={"reviewervisible_" + list.id}
                    defaultChecked={list.reviewerVisible ? true : false}
                    onChange={this.isReviewerVisible}
                  />
                  <span> {LocaleStrings.reviewervisible}</span>
                </div>
              ) : (
                ""
              )}
              {list.defaultfields ? (
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.uploader_file_type} :
                  </label>{" "}
                  {list.filetype}
                </div>
              ) : (
                <div className="form-group">
                  <label className="">
                    <span>{LocaleStrings.uploader_file_type}</span>
                  </label>

                  <select
                    className="form-control"
                    id={"filetype_" + list.id}
                    name={"filetype_" + list.id}
                    onChange={this.fileTypeChange}
                    defaultValue={list.filetype ? list.filetype : ""}
                  >
                    {_.map(defaultFileTypeOptions, (opt, i) => {
                      return (
                        <option
                          key={i}
                          value={opt.value}
                          // selected={
                          //   list.filetype == opt.value ? "selected" : ""
                          // }
                        >
                          {opt.text}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}
              <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {LocaleStrings.uploader_count}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="text"
                    name={"maxuploader_" + list.id}
                    id={"maxuploader_" + list.id}
                    defaultValue={list.maxupload}
                    onChange={this.maxUploaderChange}
                  />
                </div>
              </div>
              {/* <div className="form-group">
                <label style={{ textAlign: "left" }}>
                  {" "}
                  {LocaleStrings.maxuploader_size}{" "}
                </label>
                <div>
                  <input
                    className="form-control"
                    type="number"
                    max="100"
                    min="1"
                    onKeyPress={this.preventPress}
                    name={"maxuploadsize_" + list.id}
                    id={"maxuploadsize_" + list.id}
                    defaultValue={list.maxuploadsize}
                    onChange={this.maxUploaderSizeChange}
                  />
                </div>
              </div> */}
              <hr />
              <div className="">
                <button
                  id="save"
                  className="btn btn-custom-blue"
                  onClick={() => this.saveData(list)}
                >
                  {LocaleStrings.button_save}
                </button>
                &nbsp;
                <button
                  id="cancel"
                  className="btn btn-custom-white"
                  onClick={() => document.body.click()}
                >
                  {LocaleStrings.button_cancel}
                </button>
              </div>
            </div>
          ) : list.key == "group" ? (
            list.type == "abstract" ? (
              <div>
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>Title</label>
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      name={"label_" + list.id}
                      id={"label_" + list.id}
                      defaultValue={list.groupfields[0].label}
                      onChange={this.labelChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>Description</label>
                  <div>
                    <textarea
                      className="form-control"
                      name={"label_" + list.id}
                      id={"label_" + list.id}
                      onChange={this.descriptionChange}
                    >
                      {list.groupfields[1].label}
                    </textarea>
                  </div>
                </div>
                {showIsPublic === true ? (
                  <div className="form-group">
                    <input
                      type="checkbox"
                      name={"isactive_" + list.id}
                      id={"isactive_" + list.id}
                      defaultChecked={list.isactive ? true : false}
                      onChange={this.isActive}
                    />
                    <span> {LocaleStrings.public}</span>
                  </div>
                ) : (
                  ""
                )}
                <hr />
                <div className="">
                  <button
                    id="save"
                    className="btn btn-custom-blue"
                    onClick={() => this.saveData(list)}
                  >
                    {LocaleStrings.button_save}
                  </button>
                  &nbsp;
                  <button
                    id="cancel"
                    className="btn btn-custom-white"
                    onClick={() => document.body.click()}
                  >
                    {LocaleStrings.button_cancel}
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.label}
                  </label>
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      name={"label_" + list.id}
                      id={"label_" + list.id}
                      defaultValue={list.label}
                      onChange={this.labelChange}
                    />
                  </div>
                </div>
                {list.defaultfields ? (
                  <div className="form-group">
                    <label style={{ textAlign: "left" }}>
                      {LocaleStrings.variable} :
                    </label>{" "}
                    {list.name}
                  </div>
                ) : (
                  <div className="form-group">
                    <label style={{ textAlign: "left" }}>
                      {LocaleStrings.variable}
                    </label>
                    <div>
                      <input
                        className="form-control"
                        type="text"
                        name={"variable_" + list.id}
                        id={"variable_" + list.id}
                        value={variableName}
                        onChange={this.variableChange}
                      />
                    </div>
                  </div>
                )}
                {showIsPublic === true ? (
                  <div className="form-group">
                    <input
                      type="checkbox"
                      name={"isactive_" + list.id}
                      id={"isactive_" + list.id}
                      defaultChecked={list.isactive ? true : false}
                      onChange={this.isActive}
                    />
                    <span> {LocaleStrings.public}</span>
                  </div>
                ) : (
                  ""
                )}
                <div className="form-group">
                  <label style={{ textAlign: "left" }}>
                    {LocaleStrings.maxentries}
                  </label>
                  <div>
                    <input
                      className="form-control"
                      type="number"
                      name={"maxentries_" + list.id}
                      id={"maxentries_" + list.id}
                      defaultValue={list.maxentries}
                      onChange={this.maxGroupDataEnteries}
                    />
                  </div>
                </div>
                <hr />
                <div className="">
                  <button
                    id="save"
                    className="btn btn-custom-blue"
                    onClick={() => this.saveData(list)}
                  >
                    {LocaleStrings.button_save}
                  </button>
                  &nbsp;
                  <button
                    id="cancel"
                    className="btn btn-custom-white"
                    onClick={() => document.body.click()}
                  >
                    {LocaleStrings.button_cancel}
                  </button>
                </div>
              </div>
            )
          ) : (
            ""
          )}
        </div>
      </Popover>
    );
  };

  /**
   * =============================================================================================
   */

  isReviewerVisible = (e) => {
    this.setState({ reviewerVisible: e.target.checked });
  };

  render() {
    var { list, draggedId } = this.props;

    if (draggedId != "" && draggedId == list.id) {
    }

    return (
      <div draggable="false" style={{ zIndex: 1056 }}>
        {list.key === "textinput" ||
        list.key === "numberinput" ||
        list.key === "textarea" ? (
          <div className="SortableItem rfb-item">
            <div>
              <div className="toolbar-header">
                <span className="label label-default">{list.header}</span>
                {list.defaultfields == "fixed" ? (
                  ""
                ) : (
                  <div className="toolbar-header-buttons">
                    <div className="is-isolated">
                      <OverlayTrigger
                        trigger="click"
                        placement="left"
                        overlay={this.formData()}
                        rootClose={true}
                      >
                        <img
                          // className="is-isolated fa fa-pencil-square-o"
                          src="../../style/images/checkoutform/edit.png"
                          onClick={() => this.openedList(list)}
                        ></img>
                      </OverlayTrigger>
                    </div>
                    <div className="is-isolated">
                      <img
                        // className="is-isolated fa fa-trash-o"
                        src="../../style/images/checkoutform/trash.png"
                        onClick={this.removeFromList}
                      ></img>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="form-group">
              <label className="">
                <span>{list.label}</span>
                {list.required ? (
                  <span style={{ paddingLeft: 3, color: "red" }}>*</span>
                ) : (
                  ""
                )}
              </label>
              {list.key === "textarea" ? (
                <div style={{ display: "flex" }}>
                  <img
                    className="drag-dots"
                    src="../../style/images/checkoutform/drag-dots.png"
                  ></img>
                  <textarea
                    className="form-control"
                    name={list.name}
                  ></textarea>
                </div>
              ) : list.key === "textinput" ? (
                <div className="" style={{ display: "flex" }}>
                  <img
                    className="drag-dots"
                    src="../../style/images/checkoutform/drag-dots.png"
                  ></img>

                  <input
                    type="text"
                    className="form-control"
                    id={list.id}
                    name={list.name}
                    style={
                      list.defaultfields == "fixed"
                        ? { backgroundColor: "#eceeef" }
                        : {}
                    }
                  />
                </div>
              ) : (
                <div className="" style={{ display: "flex" }}>
                  <img
                    className="drag-dots"
                    src="../../style/images/checkoutform/drag-dots.png"
                  ></img>

                  <input
                    type="number"
                    className="form-control"
                    name={list.name}
                    id={list.id}
                  />
                </div>
              )}
            </div>
          </div>
        ) : list.key === "dropdown" ||
          list.key === "checkboxes" ||
          list.key === "radiobuttons" ? (
          <div className="SortableItem rfb-item">
            <div>
              <div className="toolbar-header">
                <span className="label label-default">{list.header}</span>
                {list.defaultfields == "fixed" ? (
                  ""
                ) : (
                  <div className="toolbar-header-buttons">
                    <div className="is-isolated">
                      <OverlayTrigger
                        trigger="click"
                        placement="left"
                        overlay={this.formData()}
                        rootClose={true}
                        // ref={(r) => (this.overlayRef = r)}
                      >
                        <img
                          // className="is-isolated fa fa-pencil-square-o"
                          src="../../style/images/checkoutform/edit.png"
                          onClick={() => this.openedList(list)}
                        ></img>
                      </OverlayTrigger>
                    </div>
                    <div className="is-isolated">
                      <img
                        // className="is-isolated fa fa-trash-o"
                        src="../../style/images/checkoutform/trash.png"
                        onClick={this.removeFromList}
                      ></img>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="form-group">
              <div style={{ display: "flex" }}>
                <img
                  className="drag-dots"
                  src="../../style/images/checkoutform/drag-dots.png"
                ></img>
                <label className="">
                  <span>{list.label}</span>
                  {list.required ? (
                    <span style={{ paddingLeft: 3, color: "red" }}>*</span>
                  ) : (
                    ""
                  )}
                </label>
              </div>
              {list.key === "dropdown" ? (
                <select className="form-control" name={list.name}>
                  {_.map(list.options, (opt, i) => {
                    return (
                      <option key={i} id={list.id} defaultValue={opt.value}>
                        {opt.text}
                      </option>
                    );
                  })}
                </select>
              ) : list.key === "checkboxes" ? (
                _.map(list.options, (opt, i) => {
                  return (
                    <div key={i}>
                      <input
                        name={list.name + "_" + i}
                        id={list.id}
                        type="checkbox"
                        defaultValue={opt.value}
                      />{" "}
                      {opt.text}
                    </div>
                  );
                })
              ) : (
                _.map(list.options, (opt, i) => {
                  return (
                    <div key={i}>
                      <input
                        name={list.name}
                        id={list.id}
                        type="radio"
                        defaultValue={opt.value}
                      />{" "}
                      {opt.text}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        ) : list.key === "singlecheckbox" ? (
          <div className="SortableItem rfb-item">
            <div>
              <div className="toolbar-header">
                <span className="label label-default">{list.header}</span>
                <div className="toolbar-header-buttons">
                  <div className="is-isolated">
                    <OverlayTrigger
                      trigger="click"
                      placement="left"
                      overlay={this.formData()}
                      rootClose={true}
                    >
                      <img
                        // className="is-isolated fa fa-pencil-square-o"
                        src="../../style/images/checkoutform/edit.png"
                        onClick={() => this.openedList(list)}
                      ></img>
                    </OverlayTrigger>
                  </div>
                  {/* <div className="btn is-isolated btn-school"><i className="is-isolated fa fa-trash-o" onClick={this.removeFromList}></i></div> */}
                </div>
              </div>
            </div>
            <div className="form-group" style={{ display: "flex" }}>
              <img
                className="drag-dots"
                src="../../style/images/checkoutform/drag-dots.png"
              ></img>
              <input
                name={list.name}
                id={list.id}
                type="checkbox"
                defaultValue={false}
              />{" "}
              <label className="" style={{ marginLeft: "10px" }}>
                <span>{list.label}</span>
                {list.required ? (
                  <span style={{ paddingLeft: 3, color: "red" }}>*</span>
                ) : (
                  ""
                )}
              </label>
            </div>
          </div>
        ) : list.key === "image" ? (
          <div className="SortableItem rfb-item">
            <div className="toolbar-header">
              <span className="label label-default">{list.header}</span>
              <div className="toolbar-header-buttons">
                <div className="is-isolated">
                  <OverlayTrigger
                    trigger="click"
                    placement="left"
                    overlay={this.formData()}
                    rootClose={true}
                  >
                    <img
                      // className="is-isolated fa fa-pencil-square-o"
                      src="../../style/images/checkoutform/edit.png"
                      onClick={() => this.openedList(list)}
                    ></img>
                  </OverlayTrigger>
                </div>
                <div className="is-isolated">
                  <i
                    // className="is-isolated fa fa-trash-o"
                    src="../../style/images/checkoutform/trash.png"
                    onClick={this.removeFromList}
                  ></i>
                </div>
              </div>
            </div>
            <div className="no-image">No Image</div>
          </div>
        ) : list.key === "hyperlink" ? (
          <div className="SortableItem rfb-item">
            <div>
              <div className="toolbar-header">
                {/* <span className="label label-default">{list.header}sss</span> */}
                <div
                  className="toolbar-header-buttons"
                  style={{ marginTop: 0 }}
                >
                  <div className="is-isolated">
                    <OverlayTrigger
                      trigger="click"
                      placement="left"
                      overlay={this.formData()}
                      rootClose={true}
                    >
                      <img
                        // className="is-isolated fa fa-pencil-square-o"
                        src="../../style/images/checkoutform/edit.png"
                        onClick={() => this.openedList(list)}
                      ></img>
                    </OverlayTrigger>
                  </div>
                  <div className="is-isolated">
                    <img
                      // className="is-isolated fa fa-trash-o"
                      src="../../style/images/checkoutform/trash.png"
                      onClick={this.removeFromList}
                    ></img>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group" style={{ display: "flex" }}>
              <img
                className="drag-dots"
                src="../../style/images/checkoutform/drag-dots.png"
              ></img>
              <a target="_blank" name={list.name} id={list.id} href="#">
                {list.label}
              </a>
            </div>
          </div>
        ) : list.key === "rating" ? (
          <div className="SortableItem rfb-item">
            <div>
              <div className="toolbar-header">
                <span className="label label-default">{list.header}</span>
                <div className="toolbar-header-buttons">
                  <div className="is-isolated">
                    <OverlayTrigger
                      trigger="click"
                      placement="left"
                      overlay={this.formData()}
                      rootClose={true}
                    >
                      <img
                        // className="is-isolated fa fa-pencil-square-o"
                        src="../../style/images/checkoutform/edit.png"
                        onClick={() => this.openedList(list)}
                      ></img>
                    </OverlayTrigger>
                  </div>
                  <div className="is-isolated">
                    <img
                      // className="is-isolated fa fa-trash-o"
                      src="../../style/images/checkoutform/trash.png"
                      onClick={this.removeFromList}
                    ></img>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label className="">
                <span>{list.label}</span>
                {list.required ? (
                  <span style={{ paddingLeft: 3, color: "red" }}>*</span>
                ) : (
                  ""
                )}
              </label>
              <span className="react-star-rating">
                <span
                  className="react-star-rating__root rating-editing"
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="rating-container rating-gly-star"
                    data-content="★★★★★"
                  >
                    <div
                      className="rating-stars"
                      data-content="★★★★★"
                      style={{ width: 0 }}
                    ></div>
                  </div>
                  {/* <input
                    type="number"
                    name={list.name}
                    id={list.id}
                    min="0"
                    max="5"
                    readOnly=""
                    defaultValue="0"
                    style={{ width: 65 }}
                  /> */}
                </span>
              </span>
            </div>
          </div>
        ) : list.key === "datepicker" ? (
          <div className="SortableItem rfb-item">
            <div>
              <div className="toolbar-header">
                <span className="label label-default">{list.header}</span>
                <div className="toolbar-header-buttons">
                  <div className="is-isolated">
                    <OverlayTrigger
                      trigger="click"
                      placement="left"
                      overlay={this.formData()}
                      rootClose={true}
                    >
                      <img
                        // className="is-isolated fa fa-pencil-square-o"
                        src="../../style/images/checkoutform/edit.png"
                        onClick={() => this.openedList(list)}
                      ></img>
                    </OverlayTrigger>
                  </div>
                  <div className="is-isolated">
                    <img
                      // className="is-isolated fa fa-trash-o"
                      src="../../style/images/checkoutform/trash.png"
                      onClick={this.removeFromList}
                    ></img>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div style={{ display: "flex" }}>
                <img
                  className="drag-dots"
                  src="../../style/images/checkoutform/drag-dots.png"
                ></img>
                <label className="">
                  <span>{list.label}</span>
                  {list.required ? (
                    <span style={{ paddingLeft: 3, color: "red" }}>*</span>
                  ) : (
                    ""
                  )}
                </label>
              </div>
              <div>
                <div className="react-datepicker-wrapper">
                  <div className="react-datepicker__input-container">
                    <input
                      type="text"
                      name={list.name}
                      id={list.id}
                      placeholder="mm/dd/yyyy"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : list.key === "label" || list.key === "paragraph" ? (
          <div className="SortableItem rfb-item">
            <div>
              <div className="toolbar-header">
                {/* <span className="label label-default">{list.header}</span> */}
                <div
                  className="toolbar-header-buttons"
                  style={{ marginTop: 0 }}
                >
                  <div className="is-isolated">
                    <OverlayTrigger
                      trigger="click"
                      placement="left"
                      overlay={this.formData()}
                      rootClose={true}
                    >
                      <img
                        // className="is-isolated fa fa-pencil-square-o"
                        src="../../style/images/checkoutform/edit.png"
                        onClick={() => this.openedList(list)}
                      ></img>
                    </OverlayTrigger>
                  </div>
                  <div className="is-isolated ">
                    <img
                      // className="is-isolated fa fa-trash-o"
                      src="../../style/images/checkoutform/trash.png"
                      onClick={this.removeFromList}
                    ></img>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group" style={{ display: "flex" }}>
              <img
                className="drag-dots"
                src="../../style/images/checkoutform/drag-dots.png"
              ></img>
              <label id={list.id}>{list.label}</label>
            </div>
          </div>
        ) : list.key == "file" ? (
          <div className="SortableItem rfb-item">
            <div>
              <div className="toolbar-header">
                <span className="label label-default">{list.header}</span>
                {list.defaultfields == "fixed" ? (
                  ""
                ) : (
                  <div className="toolbar-header-buttons">
                    <div className="is-isolated">
                      <OverlayTrigger
                        trigger="click"
                        placement="left"
                        overlay={this.formData()}
                        rootClose={true}
                      >
                        <img
                          // className="is-isolated fa fa-pencil-square-o"
                          src="../../style/images/checkoutform/edit.png"
                          onClick={() => this.openedList(list)}
                        ></img>
                      </OverlayTrigger>
                    </div>
                    <div className="is-isolated">
                      <img
                        // className="is-isolated fa fa-trash-o"
                        src="../../style/images/checkoutform/trash.png"
                        onClick={this.removeFromList}
                      ></img>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="form-group">
              <label className="">
                <span>{list.label}</span>
                {list.required ? (
                  <span style={{ paddingLeft: 3, color: "red" }}>*</span>
                ) : (
                  ""
                )}
              </label>
              <div>
                <input
                  type="file"
                  name={list.name}
                  id={list.id}
                  placeholder=""
                  className="form-control"
                />
              </div>
            </div>
          </div>
        ) : list.key == "group" ? (
          list.type == "abstract" ? (
            <div className="SortableItem rfb-item">
              <div className="row">
                <div className="col-md-12">
                  <div>
                    <div className="toolbar-header">
                      <div className="toolbar-header-buttons">
                        <div
                          className="is-isolated"
                          style={{ paddingTop: "10px" }}
                        >
                          <OverlayTrigger
                            trigger="click"
                            placement="left"
                            overlay={this.formData()}
                            rootClose={true}
                          >
                            <img
                              // className="is-isolated fa fa-pencil-square-o"
                              src="../../style/images/checkoutform/edit.png"
                              onClick={() => this.openedList(list)}
                            ></img>
                          </OverlayTrigger>
                        </div>
                        <div className="btn is-isolated btn-school">
                          <img
                            // className="is-isolated fa fa-trash-o"
                            src="../../style/images/checkoutform/trash.png"
                            onClick={this.removeFromList}
                          ></img>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="form-group"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img
                      className="drag-dots"
                      src="../../style/images/checkoutform/drag-dots.png"
                    ></img>
                    <div>
                      <div className="form-group">
                        <label id={list.id}>{list.groupfields[0].label}</label>
                      </div>
                      <div className="form-group">
                        <label id={list.id}>{list.groupfields[1].label}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="SortableItem rfb-item">
              <div>
                <div className="toolbar-header">
                  <span className="label label-default">{list.header}</span>
                  {list.defaultfields == "fixed" ? (
                    ""
                  ) : (
                    <div className="toolbar-header-buttons">
                      <div className="is-isolated">
                        <OverlayTrigger
                          trigger="click"
                          placement="left"
                          overlay={this.formData()}
                          rootClose={true}
                        >
                          <img
                            // className="is-isolated fa fa-pencil-square-o"
                            src="../../style/images/checkoutform/edit.png"
                            onClick={() => this.openedList(list)}
                          ></img>
                        </OverlayTrigger>
                      </div>
                      <div className="is-isolated">
                        <img
                          // className="is-isolated fa fa-trash-o"
                          src="../../style/images/checkoutform/trash.png"
                          onClick={this.removeFromList}
                        ></img>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label className="">
                  <span>{list.label}</span>
                  {list.required ? (
                    <span style={{ paddingLeft: 3, color: "red" }}>*</span>
                  ) : (
                    ""
                  )}
                </label>
                {list.type == "products" ? (
                  <div className="row">
                    <div className="col-md-4">
                      <img
                        src="../../style/images/dummy-image.png"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-6">
                          <select className="form-control">
                            <option>Select category</option>;
                          </select>
                        </div>
                        <div className="col-md-6">
                          <select className="form-control">
                            <option>Select sub-category</option>;
                          </select>
                        </div>
                        <div className="col-md-12">
                          <h2>Name</h2>
                        </div>
                        <div className="col-md-12">
                          <p>
                            Wish to showcase a product/service? Upload images
                            and supporting documents to promote it to
                            participants.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : list.type == "coupons" ? (
                  <div className="row">
                    <div className="col-md-12">
                      <h2>Title</h2>
                    </div>
                    <div className="col-md-12">
                      <p>
                        Do you want to offer a coupon to customers? Add the
                        coupon code and the validity date here to get started.
                      </p>
                    </div>
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="react-datepicker-wrapper">
                            <div className="react-datepicker__input-container">
                              <input
                                type="text"
                                placeholder="mm/dd/yyyy"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row">
                            <div
                              className="col-md-7"
                              style={{ paddingTop: 10 }}
                            >
                              #COUPON CODE
                            </div>
                            <div className="col-md-5">
                              <button className="btn btn-custom-blue">
                                Copy Code
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : list.type == "deals" ? (
                  <div className="row">
                    <div className="col-md-12">
                      <h2>Title</h2>
                    </div>
                    <div className="col-md-12">
                      <p>
                        Want to give a deal on your business services to
                        potential clients? Add the deal date here.
                      </p>
                    </div>
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-8">
                          <div className="react-datepicker-wrapper">
                            <div className="react-datepicker__input-container">
                              <input
                                type="text"
                                placeholder="mm/dd/yyyy"
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <button className="btn btn-custom-blue">
                            Get the deal
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          )
        ) : list.key == "interestcheckboxes" ? (
          <div className="SortableItem rfb-item">
            <div>
              <div className="toolbar-header">
                <span className="label label-default">{list.header}</span>
              </div>
            </div>
            <div className="form-group">
              <label className="header-form">
                <span>{list.label}</span>
                {list.required ? (
                  <span style={{ paddingLeft: 3, color: "red" }}>*</span>
                ) : (
                  ""
                )}
              </label>
              <div className="interest-section">
                {_.map(list.options, (opt, i) => {
                  return (
                    <div key={`interest_${i}`} className="interest-list">
                      {opt.text}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    oldKeys: state.formList,
    formName: state.formName,
  };
}

export default connect(mapStateToProps, {
  updateFormList,
  updateNewFormList,
  formEdited,
  showError,
  showSuccess,
})(FormList);
